export default __webpack_public_path__ + "static/stark-en-fit-d364d1be0906dc4aff87d1d7cbf08516.svg";